import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import Layout, { LayoutContent } from '../../components/Layout';
import NextLink from '../../components/NextLink';
import H1 from '../../components/H1';
import config from '../../config/config';
import { TP } from '../../constants/consts';
import route from '../../constants/routes';

const { APP_ENV } = config;
const useStyles = makeStyles(() => ({
  status: {},
}));

const codes = {
  400: {
    code: 400,
    message: 'Bad Request!',
    content: 'You have used invalid syntax.',
  },
  401: {
    code: 401,
    message: 'Unauthorized!',
    content: 'The URL requested requires authorization.',
  },
  403: {
    code: 403,
    message: 'Forbidden!',
    content: 'You are not permitted to access the requested URL.',
  },
  404: {
    code: 404,
    message: 'Not Found!',
    content: 'The requested URL was not found on this server.',
  },
  405: {
    code: 405,
    message: 'Method Not Allowed!',
    content: 'The method used is not permitted.',
  },
  500: {
    code: 500,
    message: 'Internal Server Error!',
    content: 'The requested URL caused an internal server error.',
  },
  502: {
    code: 500,
    message: 'Bad Gateway!',
    content: 'This server received an invalid response from an upstream server it accessed to fulfill the request.',
  },
  503: {
    code: 500,
    message: 'Service Unavailable!',
    content: 'The Service is not available at the moment due to a temporary overloading or maintenance of the server.',
  },
};

const ErrorPage = ({ statusCode, error }) => {
  const classes = useStyles();
  const code = get(codes, statusCode, codes[500]);
  const customBreadcrumbs = [{ path: route.HOME, title: `${TP}.m_HOME` }];

  return (
    <Layout customBreadcrumbs={customBreadcrumbs} title={`${get(code, 'code')} - ${get(code, 'message')}`}>
      <LayoutContent variant="regular">
        <div className={classes.status}>
          <H1>{`${get(code, 'code')} - ${get(code, 'message')}`}</H1>
        </div>
        <div className={classes.status}>
          <h3>The following error occurred:</h3>
          <p>{get(code, 'content')}</p>
          <p>
            Please <NextLink href="/contact">contact the administration</NextLink> with any queries.
          </p>
          <p>{APP_ENV && APP_ENV !== 'production' && error && error}</p>
        </div>
      </LayoutContent>
    </Layout>
  );
};

ErrorPage.propTypes = {
  t: PropTypes.func,
  statusCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ErrorPage;
